import { filter, findIndex, map, find } from 'lodash-es';

export default {

  /**
   * Filters the list of filters by selected brands and products.
   *
   * @param state
   */
  filteredFilters(state) {
    let items = state.list.items;

    if (!items) {
      return [];
    }

    if (!state.list.products.length && !state.list.brands.length) {
      return items;
    }

    if (state.list.brands.length) {
      /* eslint-disable-next-line arrow-body-style */
      items = filter(items, (item) => {
        return findIndex(item.brands, brand => state.list.brands.indexOf(brand.id) > -1) > -1;
      });
    }

    if (state.list.products.length) {
      items = filter(items, item => state.list.products.indexOf(item.product.id) > -1);
    }

    return items;
  },

  /**
   * Payload for updating a filter
   *
   * @param state
   */
  filterPayload(state) {
    if (state.single.general) {
      return {
        name: state.single.general.name,
        product: state.single.general.product.id,
        brands: state.single.general.brands,
        parameters: state.single.general.parameters,
        suppliers: state.single.general.suppliers,
        rules: state.single.general.rules,
      };
    }
    return {};
  },

  /**
   * Payload for updating the facilities section of a filter
   *
   * @param state
   */
  filterFacilitiesPayload(state) {
    if (state.single.facilities) {
      return {
        accommodationProperties: map(filter(state.single.facilities.accommodationProperties || [],
          property => property.selected), property => property.id),
        accommodationCategories: map(filter(state.single.facilities.accommodationCategories || [],
          category => category.selected), category => category.id),
        accommodationBedrooms: map(filter(state.single.facilities.accommodationBedrooms || [],
          bedroom => bedroom.selected), bedroom => bedroom.id),
        siteFacilities: map(filter(state.single.facilities.siteFacilities || [],
          facility => facility.selected), facility => facility.id),
      };
    }
    return {};
  },

  /**
   * Retrieves all countries related to the current filters product
   *
   * @param state
   * @param getters
   * @param rootState
   * @returns {Array}
   */
  countries(state, getters, rootState) {
    const allCountries = {
      text: 'All countries',
      value: null,
      areas: [],
    };

    if (state.single.general) {
      const products = rootState.app.auth.products;
      const currentProduct = find(products,
        product => product.slug === state.single.general.product.slug);

      if (currentProduct) {
        return [
          allCountries,
          ...map(currentProduct.countries, country => ({
            text: country.name,
            value: country.id,
            areas: country.areas,
          })),
        ];
      }
    }
    return [allCountries];
  },

  /**
   * Retrieves all areas for the selected country if any
   *
   * @param state
   * @param getters
   * @returns {Array}
   */
  areas(state, getters) {
    const allAreas = {
      text: 'All Areas',
      value: null,
    };

    if (state.single.general && state.single.general.parameters.country) {
      const selectedCountry = find(
        getters.countries,
        country => country.value === state.single.general.parameters.country,
      );

      if (selectedCountry) {
        return [
          allAreas,
          ...map(selectedCountry.areas, area => ({
            text: area.name,
            value: area.id,
          })),
        ];
      }
    }
    return [allAreas];
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/filter/getters.js